import React from 'react'

const ConsoleModal = () => {
    return (
        <div>
            asdfasdf
        </div>
    )
}

export default ConsoleModal
